import { Components, Theme } from '@mui/material/styles';

// MUI colors a tooltip with grey[700], and the dark palette's grey scale runs the other way: white on light grey.
export default function Tooltip({ palette }: Theme): Components {
  if (palette.mode !== 'dark') {
    return {};
  }

  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: palette.grey[200] },
        arrow: { color: palette.grey[200] },
      },
    },
  };
}
